import userSvg from "Content/images/user/user.svg";
import classNames from "classnames";
import isString from "lodash/isString";
import React, { useMemo } from "react";
import userToColor from "../utils/userToColor";
import Styled from "./userAvatar.styled";
import styles from "./UserAvatar.module.css";
export default function UserAvatar(props) {
    const size = isString(props.size) ? props.size : `${props.size}px`;
    const avatar = useMemo(() => (props.draftAvatar !== undefined ? props.draftAvatar : props.avatar), [props.userId, props.avatar, props.draftAvatar]);
    const { name, bgColor, textColor } = useMemo(() => userToColor(props.login, props.fullName, props.isParticipant), [props.login, props.fullName, props.isParticipant]);
    const avatarClasses = classNames(props.className, {
        [styles["avatar-participant"]]: props.isParticipant,
        [styles.avatar]: !props.isParticipant
    });
    if (avatar) {
        return (React.createElement(Styled.Avatar, { className: props.className, size: size, onClick: props.onClick, round: true, src: avatar }));
    }
    if (!avatar && !name && props.isNewUser)
        return (React.createElement("img", { className: classNames("avatar-icon border-rounded-circle", props.className), src: userSvg, alt: "", width: size, height: size, onClick: props.onClick, role: "none" }));
    return (React.createElement(Styled.Avatar, { className: avatarClasses, size: size, onClick: props.onClick, round: true, maxInitials: 2, name: name, color: bgColor, fgColor: textColor }));
}
